<i18n>
zh-TW:
  title: 閃電直發說明
  shareTitle: POIZON閃電直發服務
  shareDesc: 20日免倉儲費，出售速度更快
  tab1: 規則說明
  tab2: 操作指南

zh-TW2:
  title: 閃電直發說明
  shareTitle: POIZON閃電直發服務
  shareDesc: 20日免倉儲費，出售速度更快
  tab1: 規則說明
  tab2: 操作指南

zh-MO:
  title: 閃電直發說明
  shareTitle: POIZON閃電直發服務
  shareDesc: 20日免倉儲費，出售速度更快
  tab1: 規則說明
  tab2: 操作指南

en:
  title: Consignment Service
  shareTitle: Sell with Consignment Service on POIZON
  shareDesc: Free of storage charge for 20 days. Sell faster with our consignment service.
  tab1: Instructions
  tab2: Guide

ja:
  title: 委託販売の説明
  shareTitle: POISON委託販売サビース
  shareDesc: 20日間お預かり料金なし、快速販売!
  tab1: ルール説明
  tab2: 操作ガイド

ko:
  title: 빨리 배송 안내
  shareTitle: POIZON  빨리 배송 서비스
  shareDesc: '20일 창고비 면제, 판매 속도 빨라져'
  tab1: 규칙 설명
  tab2: 운영 가이드

</i18n>
<template>
  <section class="container">
    <div class="tab-block">
      <div
        v-for="(item, i) in tabList"
        :key="i"
        :class="i === index ? 'tab active-tab' : 'tab'"
        @click="handleChangeTab(i)"
      >
        <span>{{ item.name }}</span>
      </div>
    </div>
    <component :is="getTabComponent()"></component>
  </section>
</template>

<script>
import { mapState } from 'vuex'
import Guide from './guide/index'
import Rule from './rule/index'
import { Jockeys } from '@/utils'

export default {
  components: {
    Rule,
    Guide,
  },
  data() {
    return {
      index: Number(this.$route.query.activeTab || 0),
      tabList: [
        { name: this.$t('tab1'), tabComponent: 'Rule' },
        { name: this.$t('tab2'), tabComponent: 'Guide' },
      ],
    }
  },
  computed: {
    ...mapState(['LANG', 'AREA']),
  },
  created() {
    if (process.server) return
    const title = this.$t('title')
    Jockeys.setTitle(title)
    Jockeys.rightBarButtonItem({
      title: this.$t('shareTitle'),
      description: this.$t('shareDesc'),
      link: location.href,
    })
  },
  methods: {
    handleChangeTab(key) {
      this.index = key
    },
    getTabComponent() {
      return this.tabList[this.index].tabComponent
    },
  },
}
</script>

<style lang="scss" scoped>
.container {
  width: 750px;
  position: relative;
  .tab-block {
    display: flex;
    align-items: center;
    justify-content: space-between;
    font-size: 28px;
    font-weight: normal;
    .tab {
      width: 50%;
      color: rgb(170, 170, 187);
      font-family: PingFangSC-Regular;
      text-align: center;
      height: 88px;
      line-height: 88px;
    }
    .active-tab {
      color: rgba(0, 0, 0, 0.9);
      font-family: PingFangHK-Semibold;
      font-weight: 600;
      span {
        padding-bottom: 22px;
        border-bottom: 4px solid rgba(0, 0, 0, 0.9);
      }
    }
  }
}
</style>
